import { render, staticRenderFns } from "./AssetsHistoryTable.vue?vue&type=template&id=f2e3cdf8&scoped=true&"
import script from "./AssetsHistoryTable.vue?vue&type=script&lang=js&"
export * from "./AssetsHistoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e3cdf8",
  null
  
)

export default component.exports